import type { ITableSort } from "app/components/React/Table/types";
import { EState } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/types";
import { defaultColumns } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/columns/defaultColumns";
import { yearOverYearColumns } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/columns/yearOverYearColumns";
import { periodOverPeriodColumns } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/columns/periodOverPeriodColumns";

const stateColumns = {
    [EState.DEFAULT]: defaultColumns,
    [EState.PERIOD_OVER_PERIOD]: periodOverPeriodColumns,
    [EState.YEAR_OVER_YEAR]: yearOverYearColumns,
};

export const getColumns = (sortedColumn: ITableSort, state: EState) => {
    const columns = stateColumns[state];

    return columns.map((col) => {
        const isSorted = sortedColumn && col.field === sortedColumn.field;
        return {
            ...col,
            displayName: typeof col.displayName === "function" ? col.displayName() : col.displayName,
            tooltip: typeof col.tooltip === "function" ? col.tooltip() : col.tooltip,
            visible: true,
            isSorted,
            sortDirection: isSorted ? sortedColumn.sortDirection : "desc",
        };
    });
};
